export enum EvaluationMode {
  Introduction = 'introduction',
  Respond = 'respond',
  Confirmation = 'confirmation',
  Expired = 'expired'
}
